import { ulid } from 'ulid';
import type {
	CreateVoucherInput,
	UpdateVoucherInput
} from '@/graphql/generated';
import { type VoucherFormSubmitData } from './voucher-form';

const buildVoucherInput = (
	formData: VoucherFormSubmitData,
	voucherId: string
): CreateVoucherInput | UpdateVoucherInput => {
	return {
		voucherId,
		campaignId: formData.campaignId || undefined,
		name: formData.name?.trim() || undefined,
		code: formData.code,
		isAdHoc: formData.isAdHoc,
		isCustomerSpecific: formData.isCustomerSpecific,
		customerId: formData.customerId || undefined,
		rateBindingRequired: formData.rateBindingRequired,
		rateId: formData.rateId || undefined,
		voucherDiscountTypeEnum: formData.voucherDiscountTypeEnum,
		discountValue: formData.discountValue || undefined,
		maxDiscountAmount: formData.maxDiscountAmount || undefined,
		freeTimeMinutes: formData.freeTimeMinutes || undefined,
		usageLimit: formData.usageLimit || undefined,
		isActive: formData.isActive,
		validUntilDate: formData.validUntilDate
	};
};

export const buildCreateVoucherInput = (
	formData: VoucherFormSubmitData,
	voucherId: string
): CreateVoucherInput => {
	return buildVoucherInput(formData, voucherId) as CreateVoucherInput;
};

export const buildUpdateVoucherInput = (
	formData: VoucherFormSubmitData,
	voucherId: string
): UpdateVoucherInput => {
	return buildVoucherInput(formData, voucherId) as UpdateVoucherInput;
};

export const generateIdempotentVoucherId = (): string => {
	return ulid();
};
